var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateArrowPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.575736 8.57574C0.341421 8.81005 0.341421 9.18995 0.575736 9.42426C0.810051 9.65858 1.18995 9.65858 1.42426 9.42426L0.575736 8.57574ZM9.18726 1.41274C9.18726 1.08137 8.91863 0.812745 8.58726 0.812745L3.18726 0.812745C2.85588 0.812745 2.58726 1.08137 2.58726 1.41274C2.58726 1.74412 2.85588 2.01274 3.18726 2.01274L7.98726 2.01274L7.98726 6.81274C7.98726 7.14412 8.25588 7.41274 8.58726 7.41274C8.91863 7.41274 9.18726 7.14412 9.18726 6.81274L9.18726 1.41274ZM1.42426 9.42426L9.01152 1.83701L8.16299 0.988481L0.575736 8.57574L1.42426 9.42426Z",
    fill: "#E9A5F3",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrowPink);
export default __webpack_public_path__ + "static/media/rotate-arrow-pink.a949f2d03353c713227be9e07fbefe4f.svg";
export { ForwardRef as ReactComponent };